// extracted by mini-css-extract-plugin
export var barContainer = "_43-0";
export var extraThin = "_43-3";
export var fillBar = "_43-6";
export var fillContainer = "_43-4";
export var overflow = "_43-8";
export var overflowContainer = "_43-5";
export var regular = "_43-7";
export var thick = "_43-1";
export var thin = "_43-2";